import { render, staticRenderFns } from "./turn.vue?vue&type=template&id=ae1f8f4e&"
import script from "./turn.vue?vue&type=script&lang=js&"
export * from "./turn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports